import React, { useMemo, useState } from "react";
import Styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import linkIcon from "../../../theme/assets/svg/b_cabinet_partners_link_icon.svg";
import copyIcon from "../../../theme/assets/svg/b_cabinet_partners_copy_icon.svg";

const getReferralLink = (code) => {
    if (!code) return "";

    const safeCode = encodeURIComponent(code);

    if (typeof window === "undefined") {
        return `/sign-up/${safeCode}`;
    }

    return `${window.location.origin}/sign-up/${safeCode}`;
};

const CabinetPartnersLinks = () => {
    const { t } = useTranslation();

    const partnersMainData = useSelector(store => store.cabinet.partnersMainData);

    const referralCode = partnersMainData?.referral_code || "";

    const referralLink = useMemo(() => {
        return getReferralLink(referralCode);
    }, [referralCode]);

    const [copiedType, setCopiedType] = useState("");

    const copyHandler = async (value, type) => {
        if (!value) return;

        try {
            await navigator.clipboard.writeText(value);
            setCopiedType(type);

            setTimeout(() => {
                setCopiedType("");
            }, 1600);
        } catch (error) {
            console.error("Copy failed:", error);
        }
    };

    const sharePresentationHandler = () => {
        console.log("Share presentation");
    };

    return (
        <div className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetCard}`}>
                <div className={Styles.title}>
                    {t("Партнёрские данные")}
                </div>

                <div className={Styles.fieldsWrap}>
                    <div className={Styles.fieldItem}>
                        <div className={Styles.fieldTitleRow}>
                            <div className={Styles.fieldIcon}>
                                <img src={linkIcon} alt={t("Реферальная ссылка")} />
                            </div>

                            <div className={Styles.fieldTitle}>
                                {t("Реферальная ссылка")}
                            </div>
                        </div>

                        <div className={Styles.copyField}>
                            <div className={Styles.copyValue}>
                                {referralLink || "—"}
                            </div>

                            <button
                                type="button"
                                className={Styles.copyBtn}
                                onClick={() => copyHandler(referralLink, "link")}
                                disabled={!referralLink}
                            >
                                {copiedType === "link" ? t("Скопировано") : t("Копировать")}
                            </button>
                        </div>
                    </div>

                    <div className={Styles.fieldItem}>
                        <div className={Styles.fieldTitleRow}>
                            <div className={Styles.fieldIcon}>
                                <img src={copyIcon} alt={t("Реферальный код")} />
                            </div>

                            <div className={Styles.fieldTitle}>
                                {t("Реферальный код")}
                            </div>
                        </div>

                        <div className={Styles.copyField}>
                            <div className={Styles.copyValue}>
                                {referralCode || "—"}
                            </div>

                            <button
                                type="button"
                                className={Styles.copyBtn}
                                onClick={() => copyHandler(referralCode, "code")}
                                disabled={!referralCode}
                            >
                                {copiedType === "code" ? t("Скопировано") : t("Копировать")}
                            </button>
                        </div>
                    </div>
                </div>

                <div className={Styles.materialsTitle}>
                    {t("Реферальные материалы")}:
                </div>

                <button
                    type="button"
                    className={Styles.presentationBtn}
                    onClick={sharePresentationHandler}
                >
                    {t("Поделиться презентацией")}
                </button>
            </div>
        </div>
    );
};

export default CabinetPartnersLinks;